import { BarcodeType, DbRef } from '@caresend/types';
import { arrayToObj, isNullish, nullishFilter } from '@caresend/utils';
import { usePortalStore } from '../../components/specific/portal/store/portal/index.js';
import 'firebase/auth';
import '../../database/firebaseConfig/cloudFunctions.js';
import '../../database/firebaseConfig/init.js';
import { getValueOnce } from '../../database/firebaseConfig/methods.js';
import '@sentry/vue';
import '@fortawesome/fontawesome-svg-core';
import '@fortawesome/sharp-regular-svg-icons';
import 'buefy';
import '../../components/ui/Icon.vue.js';
import '../configuration/icons.js';
import '../../database/algoliaConfig/indices.js';
import 'mobile-device-detect';
import '../tracking/index.js';
import '../../router/helpers/initRouter.js';
import { getStore } from '../../store/helpers/initStore.js';
import '@firebase/auth';
import 'browser-image-compression';
import 'firebase/storage';
import 'js-sha256';
import '../../store/modules/app/model.js';
import { hasBarcodeType } from './scanning.js';
import '../../store/modules/procedures/model.js';

// SUPPLY
const getSupplyNameByID = (supplyID) => {
    if (isNullish(supplyID))
        return;
    const supply = getStore().getters['variables/getSupplyByID'](supplyID);
    if (!supply)
        return;
    const { name } = supply;
    return name.replace('CareSend ', '');
};
// SUPPLY ITEM
const getSupplyItemFromSupplyItemBarcode = async (item) => {
    const barcodeID = item.barcode.id;
    const { supplyID } = item;
    // Confirm the supply item exists in the db.
    const supplyItem = await getValueOnce(`${DbRef.SUPPLY_ITEMS}/${barcodeID}`);
    if (!supplyItem)
        return null;
    const supplyItemWithSupplyID = {
        id: supplyItem.id,
        // Missing supplyID is normal in some cases where we do not pass it in
        // with itemsToScan.
        supplyID: supplyID !== null && supplyID !== void 0 ? supplyID : 'undefined supplyID',
    };
    return supplyItemWithSupplyID;
};
const getSupplyItemsFromBatchItem = async (itemToScan) => {
    const barcodeID = itemToScan.barcode.id;
    const { skuID, supplyID } = itemToScan;
    const batchItem = await getValueOnce(`${DbRef.BATCH_ITEMS}/${barcodeID}`);
    const individualSkuID = await getValueOnce(`${DbRef.BATCH_SKUS}/${skuID}/individualSkuID`);
    if (!batchItem) {
        return [];
    }
    const supplyItemPromises = batchItem.serials.map(async (serial) => {
        const supplyItemID = `${individualSkuID}-${serial}`;
        // Confirm the supply item exists in the db.
        const supplyItem = await getValueOnce(`${DbRef.SUPPLY_ITEMS}/${supplyItemID}`);
        if (!supplyItem) {
            return null;
        }
        const supplyItemWithSupplyID = {
            id: supplyItem.id,
            supplyID: supplyID !== null && supplyID !== void 0 ? supplyID : 'undefined supplyID',
        };
        return supplyItemWithSupplyID;
    });
    const supplyItems = await Promise.all(supplyItemPromises);
    return supplyItems.filter(nullishFilter);
};
const getSupplyItemsFromItemsToScan = async (itemsToScan) => {
    const supplyItemPromises = itemsToScan.map(async (item) => {
        if (hasBarcodeType(item, BarcodeType.BATCH_ITEM)) {
            return getSupplyItemsFromBatchItem(item);
        }
        if (hasBarcodeType(item, BarcodeType.SUPPLY_ITEM)) {
            const supplyItem = await getSupplyItemFromSupplyItemBarcode(item);
            return supplyItem ? [supplyItem] : [];
        }
        // Fall back to using supplyID and supplyItemID on scannable item if
        // barcode is not available.
        if (item.supplyID && item.supplyItemID) {
            return [{
                    id: item.supplyItemID,
                    supplyID: item.supplyID,
                }];
        }
        return [];
    });
    const supplyItemsArray = (await Promise.all(supplyItemPromises)).flat();
    return arrayToObj(supplyItemsArray, 'id');
};
/**
 * Checks if the supply item is in a procedure bag on any of the procedures
 * on a given waypoint.
 *
 * TODO: Analyze if needed?
 */
const supplyItemAlreadyInProcedureBagAtThisWaypoint = (waypointID, supplyItemID) => {
    var _a;
    const portalStore = usePortalStore();
    const waypoint = portalStore.waypoints.getRaw(waypointID);
    const procedures = Object.values((_a = waypoint === null || waypoint === void 0 ? void 0 : waypoint.waypointActions) !== null && _a !== void 0 ? _a : {})
        .reduce((acc, { id }) => {
        const wpa = portalStore.waypointActions.get(id);
        return {
            ...acc,
            ...wpa === null || wpa === void 0 ? void 0 : wpa.computed.procedures,
        };
    }, {});
    return Object.values(procedures)
        .some((procedure) => {
        var _a, _b;
        return ((_a = procedure === null || procedure === void 0 ? void 0 : procedure.kitSupplyItem) === null || _a === void 0 ? void 0 : _a.id) === supplyItemID
            || ((_b = procedure === null || procedure === void 0 ? void 0 : procedure.supplyItems) === null || _b === void 0 ? void 0 : _b[supplyItemID]) !== undefined;
    });
};

export { getSupplyItemFromSupplyItemBarcode, getSupplyItemsFromBatchItem, getSupplyItemsFromItemsToScan, getSupplyNameByID, supplyItemAlreadyInProcedureBagAtThisWaypoint };
